import "./Header.css";
import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="header">
      <div className="logo">CLEAN <span id="service">SERVICE </span><span id="pro">PRO</span></div>

      <div className="burger" onClick={() => setOpen(!open)}>
        <span></span><span></span><span></span>
      </div>

      <nav className={open ? "open" : ""}>
        <a href="#services" onClick={() => setOpen(false)}>Services</a>
        <a href="#nettoyage par drone" onClick={() => setOpen(false)}>Nettoyage par Drone</a>
        <a href="#about" onClick={() => setOpen(false)}>À propos</a>
        <a href="#realisations" onClick={() => setOpen(false)}>Réalisations</a>
        <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
      </nav>
    </header>
  );
}